module.exports = __webpack_public_path__ + "img/search-no-data.e3d94a10.png";